
import Breadcrumbs from '../../../common/breadcrumb/Breadcrumbs';
import DmtCommisionForm from './dmtCommisionForm/DmtCommisionForm';
import DmtCommisionlist from './dmtCommisionList/DmtCommisionlist';


function DmtCommision() {
    return (
        <>
        <Breadcrumbs breadCrumbsTitle={{
    id: "1",
    title_1: "Commision",
    title_2: "BBPS Commision List",
  }} />
            <DmtCommisionlist/>
        </>
    )
}

export default DmtCommision